import React from 'react';
interface TCPADisclosureProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
  /** The disclosure language. Captured verbatim on the certificate. */
  children: React.ReactNode;
  /** Tailwind classes for the checkbox, so each school keeps its accent color. */
  checkboxClassName?: string;
  textClassName?: string;
}

/**
 * TCPA consent block with Jornaya (Verisk LeadiD) tagging.
 *
 * Jornaya locates the hidden input by the exact id `leadid_tcpa_disclosure`,
 * then reads the disclosure text and measures its on-screen visibility from the
 * label pointing at that id. Without this pairing the certificate comes back
 * with `tcpa.disclosure` and `tcpa.visibility` missing and buyers reject it.
 *
 * The label must contain ONLY the disclosure language, so the opt-in checkbox
 * is a sibling rather than nested inside it.
 *
 * Render at most one of these per page — the id must be unique.
 */
export function TCPADisclosure({
  checked,
  onChange,
  error,
  children,
  checkboxClassName = 'mt-0.5 h-4 w-4 rounded border-gray-300 cursor-pointer flex-shrink-0',
  textClassName = 'text-xs text-gray-600 leading-relaxed cursor-pointer'
}: TCPADisclosureProps) {
  return <div className="space-y-2 pt-2" data-id="element-975" data-mp="1uwd69mr7mpvq">
      <div className="flex items-start gap-2.5" data-id="element-976" data-mp="1uzhin7etwrxh">
        <input id="leadid_tcpa_disclosure" type="hidden" data-id="element-977" data-mp="1py1wfc0x0fdi" />
        <input id="tcpa-consent" name="tcpa-consent" type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} className={checkboxClassName} data-id="element-978" data-mp="1q0o379fzequo" />
        <label htmlFor="leadid_tcpa_disclosure" onClick={() => onChange(!checked)} className={textClassName} data-id="element-979" data-mp="1c7gd5m7ju3f3">
          {children}
        </label>
      </div>
      {error && <p className="text-xs text-red-600" data-id="element-980" data-mp="2nlappt75qsq2">{error}</p>}
    </div>;
}